<template>
  <section :class="{ 'auth-bg': isFooterVisible }">
    <router-view :callIfConnected="callIfConnected" v-slot="{ Component }">
      <transition v-if="!isSocketLoading" name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <div v-if="isSocketLoading" class="loading-wrap">
      <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
    </div>
    <!--
      Signing users are routed to an instance with a free ASL slot, which can
      take a few hops. Without this the UI is indistinguishable from a dead
      button for several seconds. Blocking on purpose: a click that lands
      mid-hop would race the action being replayed on the next instance.
    -->
    <div v-if="isPlacementVisible" class="placement-wrap">
      <v-progress-circular indeterminate color="primary" :size="70"></v-progress-circular>
      <!--
        <output> carries the status role implicitly. Scoped to the message
        rather than the whole overlay: it only accepts phrasing content, and a
        live region wrapping the Cancel button would announce the button too.
      -->
      <output class="placement-status">
        <span class="placement-title">Setting up your session…</span>
        <span class="placement-hint">This usually takes a few seconds.</span>
      </output>
      <v-btn
        v-if="isPlacementCancelVisible"
        class="custom-btn placement-cancel"
        variant="flat"
        color="primary"
        @click="handlePlacementCancel"
      >
        Cancel
      </v-btn>
    </div>
    <v-dialog
      class="settings-dialog"
      v-if="isShowUserSettings"
      :model-value="isShowUserSettings"
      content-class="settings-dialog"
      eager
      hide-overlay
      max-width="40vw"
      @click:outside="setIsShowUserSettings(false)"
      @update:modelValue="setIsShowUserSettings($event)"
    >
      <UserSettings @close="setIsShowUserSettings(false)" />
    </v-dialog>
    <v-dialog
      v-if="isShowChangePassword"
      :model-value="isShowChangePassword"
      max-width="500"
      @click:outside="setIsShowChangePassword(false)"
      @keydown.esc="setIsShowChangePassword(false)"
    >
      <ChangePasswordForm @close="setIsShowChangePassword(false)" />
    </v-dialog>

    <v-dialog
      v-if="isShowSignOutDialog"
      :model-value="isShowSignOutDialog"
      max-width="500"
      @click:outside="setIsShowSignOutDialog(false)"
      @update:modelValue="setIsShowSignOutDialog($event)"
    >
      <v-card>
        <v-card-title>{{ firstName }}, do you really want to sign out?</v-card-title>

        <v-card-actions>
          <v-btn class="custom-btn" variant="flat" color="primary" @click="handleClickSignOut">
            Yes
          </v-btn>
          <v-btn
            variant="flat"
            class="custom-btn"
            color="primary"
            @click="setIsShowSignOutDialog(false)"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-footer
      v-if="isFooterVisible"
      color="transparent"
      elevation="0"
      class="d-flex flex-column pb-4 footer-wrap"
    >
      <div>© 2026 Sorenson Communications, LLC. All Rights Reserved.</div>
      <a
        href="https://sorenson.com/privacy/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        >Privacy Policy</a
      >
    </v-footer>
  </section>
</template>

<script lang="ts" src="./index.ts" />
<style lang="scss" src="./index.scss" scoped />
